import { ApiStatus } from "../types/api/status"
import { useDispatch, useSelector } from "../redux/store"
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar"
import { readLocalStorage } from "../toolbox/helpers/local-storage-helpers"
import { LocalStorageKey } from "../types"
import { changeStatus, onFetchDocumentOfSales, onSetSelectedDocumentSale, selectDocumentOfSalesState, setAction } from "../redux/slices/documentOfSalesSlice"
import { DocumentOfSalesAPI } from "../apis/DocumentOfSalesAPI"
import { DocumentOfSale } from "../types/slices/documentOfSalesType"

export const useDocumentOfSalesStore = () => {

    const dispatch = useDispatch()
    const { documentOfSales, documentOfSaleSelected, status, action } = useSelector(selectDocumentOfSalesState)

    const userData = readLocalStorage(LocalStorageKey.USER_DATA)
    const idcompany = userData?.idcompany

    const getDocumentOfSales = async (search = '') => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await DocumentOfSalesAPI.getDocumentOfSales({ search: search })
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            const { detail } = response.data
            dispatch(onFetchDocumentOfSales(detail))
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const getDocumentOfSalesByCompany = async (search = '', params?: object) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await DocumentOfSalesAPI.getDocumentOfSalesByCompany({ search: search, idcompany: idcompany, ...params })
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            const { detail } = response.data
            dispatch(onFetchDocumentOfSales(detail))
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const setSelectedDocumentSale = (document: DocumentOfSale) => {
        try {
            dispatch(onSetSelectedDocumentSale(document))
        } catch (error) {
            console.log(error)
        }
    }

    const setActionDocumentSale = (state) => {
        try {
            dispatch(setAction(state))
        } catch (error) {
            console.log(error)
        }
    }

    const updateForCompany = async (data: any) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await DocumentOfSalesAPI.updateForCompany(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }


    return {
        //states
        documentOfSales,
        documentOfSaleSelected,
        status,
        action,
        //actions
        getDocumentOfSales,
        getDocumentOfSalesByCompany,
        setSelectedDocumentSale,
        setActionDocumentSale,
        updateForCompany
    }
}